import React, { useState } from 'react'
import Share from '../../../../media/images/share.svg'
import ShareModal from '../../widgets/components/ShareModal'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import ImageCarousel from '../../founder-market/components/Carousel'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import BlueImage from '../images/blue-bg.png'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import MiniStartupCard from './MiniStartupCard'
import AddNewDealModal from './AddNewDealModal'
import brandingConfig from '../../../../config/brandingConfig'


const YourStartups = () => {
    const { mode } = useThemeMode()
    const { formatMessage } = useIntl()
    const charLimit = 100 // Adjust the limit as needed

    const [isModalActive, setIsModalActive] = useState(false)

    // Splitting the text based on the character limit
    const [isExpandedDescription, setIsExpandedDescription] = useState(false)
    const [isExpandedUSPs, setIsExpandedUSPs] = useState(false)

    // Splitting the text based on the character limit
    const description = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam laudantium sit rerum ipsam incidunt porro tenetur fugit maxime ullam necessitatibus laborum natus assumenda consequatur odio, sint dolorum dolores nam blanditiis';
    const firstPartDescription = description.substr(0, charLimit) || '';
    const secondPartDescription = description.substr(charLimit) || '';

    const usps = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam laudantium sit rerum ipsam incidunt porro tenetur fugit maxime ullam necessitatibus laborum natus assumenda consequatur odio, sint dolorum dolores nam blanditiis';
    const firstPartUSPs = usps.substr(0, charLimit) || '';
    const secondPartUSPs = usps.substr(charLimit) || '';


    const [isActive, setIsActive] = useState(false)
    const [urlToShare, setUrlToShare] = useState('')
    const handleModal = (url: any) => {
        setIsActive(() => !isActive)
        setUrlToShare(url)
        setIsActive(true)
    }

    const tags = [
        '#Business',
        '#MSWord',
        '#agreement',
        '#document',
        '#artist',
        '#producer',
        '#influencer',
    ];
    const voters = [
        { file: '', investorUserId: '1' },
        { file: '', investorUserId: '2' },
        { file: '', investorUserId: '3' },
        { file: '', investorUserId: '4' },
        { file: '', investorUserId: '5' },
    ];
    const images = [
        BlueImage,
        BlueImage,
        BlueImage,
        BlueImage,
        BlueImage,
    ];
    return (
        <>
            <div className='p-4 bg-white rounded-3 my-4'>
                <div className='row '>
                    <div className='col-md-6 h-fc'>
                        <ImageCarousel images={images} />
                    </div>

                    <div className='resourcesDetails col-md-6 h-fc'>
                        <div className='d-flex justify-content-between'>
                            <div>
                                <div className={`px-4 py-2 category` + (mode === `dark` ? `-dark` : ``)}>
                                    Technology
                                </div>
                                <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                            </div>
                            <div className='d-flex align-items-center'>
                                <button
                                    className='btn m-0 p-0 d-block'
                                    onClick={() => handleModal(window.location.href)}
                                >
                                    <img
                                        src={Share}
                                        alt='share'
                                        className='share align-self-center'
                                        style={{ height: '24px', width: '24px', marginRight: '14px' }}
                                    />
                                </button>
                            </div>
                        </div>
                        {isActive && (
                            <ShareModal isActive={isActive} setIsActive={setIsActive} url={urlToShare} />
                        )}
                        <div className='ResourcesTitle d-flex justify-content-between align-items-center mt-2'>
                            <div>
                                <div className='d-flex'>
                                    <h1>{brandingConfig.brandName}</h1>
                                    <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                                </div>
                                <div className='d-flex'>
                                    <p className='m-0'>{formatMessage({ id: 'Fundraising Process Made Easy' })}</p>
                                    <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                                </div>

                            </div>
                            <button className="btn border border-primary rounded d-flex flex-md-column gap-2 gap-md-0 align-items-center px-6 py-3 me-2" style={{ alignSelf: 'baseline', background: '#F0F4FF' }} >
                                <span className="text-primary font-size-10">▲</span>
                                <span className="fw-bold text-primary font-size-14">620</span>
                                <span className="text-primary font-size-10">Vote</span>
                            </button>
                        </div>

                        <div className='resourceDesc my-4'>
                            <div className='d-flex'>
                                <h3>{formatMessage({ id: 'Description' })}</h3>
                                <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                            </div>
                            <p>
                                {firstPartDescription}
                                {secondPartDescription && isExpandedDescription && <span>{secondPartDescription}</span>}&nbsp;
                                {secondPartDescription && (
                                    <button className='readmore' onClick={() => setIsExpandedDescription(!isExpandedDescription)}>
                                        {isExpandedDescription
                                            ? formatMessage({ id: 'Show Less' })
                                            : formatMessage({ id: 'Read More' })}
                                    </button>
                                )}
                            </p>
                        </div>

                        <div className='resourceBenefits'>
                            <div className='d-flex'>
                                <h3>{formatMessage({ id: 'Founders' })}</h3>
                                <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                            </div>
                            <div className='d-flex flex-wrap gap-4'>
                                {Array.from({ length: 6 }, (_, index) => (
                                    <div className='d-flex' key={index}>
                                        <DisplayImage className='rounded-circle' height={32} width={32} imgName='' alt='profile-pic' />
                                        <div className='me-4'>
                                            <p className='font-size-12 fw-semibold text-dark m-0'>Toshendra Sharma</p>
                                            <p className='font-size-12 text-muted m-0'>Founder & CEO</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='mt-4'>
                            <div className='d-flex'>
                                <h3>{formatMessage({ id: 'USPs' })}</h3>
                                <button className='ms-4 text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                            </div>
                            <div className='benefitsList'>
                                <p>
                                    {firstPartUSPs}
                                    {secondPartUSPs && isExpandedUSPs && <span>{secondPartUSPs}</span>}&nbsp;
                                    {secondPartUSPs && (
                                        <button className='readmore' onClick={() => setIsExpandedUSPs(!isExpandedUSPs)}>
                                            {isExpandedUSPs
                                                ? formatMessage({ id: 'Show Less' })
                                                : formatMessage({ id: 'Read More' })}
                                        </button>
                                    )}
                                </p>
                            </div>
                        </div>

                        <div className='resourcesTags my-4 align-items-center'>
                            {tags.map((tag, index) => (
                                <p className='tag' key={index}>
                                    {tag}
                                </p>
                            ))}
                            <button className='text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                        </div>

                        <div className='my-4 d-flex align-items-center gap-4'>
                            <button
                                className='btn btn-primary d-flex align-items-center'>
                                <p className='m-0'>{formatMessage({ id: "Visit Website" })}</p>
                                <i className="fa-solid fa-up-right-from-square ps-2"></i>
                            </button>
                            <img height={28} width={28} src={toAbsoluteUrl('/media/auth/playstore-icon.svg')} alt="" />
                            <img height={28} width={28} src={toAbsoluteUrl('/media/auth/appstore-icon.svg')} alt="Appstore" />
                            <button className='text-primary bg-transparent border-0 font-size-13'>{formatMessage({ id: 'Edit' })}</button>
                        </div>
                        <div className='d-flex align-items-center col-md-4 col-12 c-profile_list py-2 position-relative my-4 mb-md-0'>
                            <>
                                {voters.slice(0, 4).map((item, index) => (
                                    <DisplayImage
                                        key={index}
                                        imgName={item.file}
                                        alt='profile'
                                        fit='contain'
                                        className='c-profile'
                                        onClickPath={`/investor-database/profile/${item.investorUserId}`}
                                    />
                                ))}
                                {voters.length - 4 > 0 && (
                                    <div
                                        className='extra-count-text-container'
                                        style={{ position: 'relative', display: 'inline' }}
                                    >
                                        <img
                                            src={toAbsoluteUrl('/media/icons/duotune/general/more_user.svg')}
                                            alt='profilepic'
                                            height='36px'
                                            width='36px'
                                            className='c-profile'
                                        />
                                        <span className='position-absolute top-50 start-50 translate-middle extra-count-text font-size-10'>
                                            +500
                                        </span>
                                    </div>
                                )}
                            </>
                            <p className='d-flex m-0 ms-2'>600+ Votes</p></div>
                    </div>
                </div>
            </div>
            <div className='d-md-flex justify-content-between align-items-center my-4'>
                <h1 className='font-size-16 mb-2 mb-md-0'>{formatMessage({ id: 'Offer on Your startup' })}</h1>
                <button className='btn btn-primary w-100 w-md-auto' onClick={() => setIsModalActive(true)}>
                    {formatMessage({ id: 'Add New Deal' })}
                </button>
            </div>
            {isModalActive && <AddNewDealModal isModalActive={isModalActive} setIsModalActive={setIsModalActive} />}
            <div className='d-md-flex gap-2 mb-2'>
                <MiniStartupCard />
                <MiniStartupCard />
            </div>
            <div className='d-md-flex gap-2 mb-2'>
                <MiniStartupCard />
                <MiniStartupCard />
            </div>
        </>
    )
}

export default YourStartups